module.exports = __webpack_public_path__ + "da67e6499dbf0ac9df2675b8e772819e.svg";